import React from "react";
import { Donut, Delta, InfoPopover } from "@/components/vb";
import { TRUST_SIGNALS_TOTAL } from "@/types/vb";
import { METRIC_INFO } from "../metricCopy";

/** AI Trust Signal exposure card (proto .expo): the donut + a plain-English line +
 *  the run-over-run signals delta. (The prototype's "Missing: …" signal list is
 *  still omitted - it needs a signal-key→name map the API doesn't ship yet.)
 *  `signalsExposed` is null when the latest run judged nothing; `signalsDelta`
 *  is the change vs the previous run (null when there's no prior run to compare). */
export function ExposureCard({
  signalsExposed,
  signalsDelta = null,
}: {
  signalsExposed: number | null;
  signalsDelta?: number | null;
}) {
  const has = signalsExposed != null;
  const n = signalsExposed ?? 0;

  return (
    <div className="vb-dcard">
      <div className="vb-dcard__hd">
        <span className="vb-dcard__lbl">AI Trust Signal exposure</span>
        <InfoPopover label="About AI Trust Signal exposure">{METRIC_INFO.signals}</InfoPopover>
      </div>
      <div className="vb-expo">
        <div className="vb-ring-wrap">
          <Donut
            value={n}
            max={TRUST_SIGNALS_TOTAL}
            tone="pass"
            label={`${n}/${TRUST_SIGNALS_TOTAL}`}
            ariaLabel={
              has
                ? `${n} of ${TRUST_SIGNALS_TOTAL} AI Trust Signals exposed`
                : "No AI Trust Signals judged in the latest run"
            }
          />
          <span className="vb-ring-cap">Exposed</span>
        </div>
        <div>
          <div className="vb-expo__t">
            {has
              ? `AI surfaced ${n} of your ${TRUST_SIGNALS_TOTAL} AI Trust Signals`
              : "No AI Trust Signals were judged in the latest run"}
          </div>
          <div className="vb-expo__d">
            {has ? (
              <>
                {signalsDelta != null && signalsDelta !== 0 && (
                  <>
                    <Delta value={signalsDelta} /> vs last run.{" "}
                  </>
                )}
                Each verbatim AI answer is judged against your AI Trust Signals. Open a run to see the evidence.
              </>
            ) : (
              "Re-run the analysis to judge how your AI Trust Signals show up in AI answers."
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ExposureCard;
